// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"mQ","contentFrame":"mR","buttonGroup":"mS","button":"mT","header":"mU","text":"mV","contentImage":"mW","closeButton":"mX"};